import * as types from './mutation-types';
import alertsService from '../../services/alerts'
import { createServiceCall } from '../actionsUtil'

export const getExceptionTypes = createServiceCall({
  mainAction: types.GET_EXCEPTION_TYPES_REQUEST,
  serviceFunction: alertsService.getExceptionTypes,
  successAction: types.GET_EXCEPTION_TYPES_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_EXCEPTION_TYPES_FAILURE
})

export const getExceptionList = createServiceCall({
  mainAction: types.GET_EXCEPTION_LIST_REQUEST,
  serviceFunction: alertsService.getExceptionList,
  successAction: types.GET_EXCEPTION_LIST_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_EXCEPTION_LIST_FAILURE
})

export const getExceptionStatuses = createServiceCall({
  mainAction: types.GET_EXCEPTION_STATUSES_REQUEST,
  serviceFunction: alertsService.getExceptionStatuses,
  successAction: types.GET_EXCEPTION_STATUSES_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_EXCEPTION_STATUSES_FAILURE
})

export const setExceptionRemediation = createServiceCall({
  mainAction: types.SET_EXCEPTION_REMEDIATION_REQUEST,
  serviceFunction: alertsService.setExceptionRemediation,
  successAction: types.SET_EXCEPTION_REMEDIATION_SUCCESS,
  successDataProperty: '',
  failureAction: types.SET_EXCEPTION_REMEDIATION_FAILURE
})

export const getExceptionRemediations = createServiceCall({
  mainAction: types.GET_EXCEPTION_REMEDIATIONS_REQUEST,
  serviceFunction: alertsService.getExceptionRemediations,
  successAction: types.GET_EXCEPTION_REMEDIATIONS_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_EXCEPTION_REMEDIATIONS_FAILURE
})

export const updateExceptionRemediation = createServiceCall({
  mainAction: types.UPDATE_EXCEPTION_REMEDIATIONS_REQUEST,
  serviceFunction: alertsService.updateExceptionRemediation,
  successAction: types.UPDATE_EXCEPTION_REMEDIATIONS_SUCCESS,
  successDataProperty: '',
  failureAction: types.UPDATE_EXCEPTION_REMEDIATIONS_FAILURE
})
